import React from 'react';
import productUtils from '../utils/productUtils';
import classnames from 'classnames';

import TableRow from './TableRow.jsx';
import AllocationsTable from './checkout/AllocationsTable.jsx';

const ProductTable = ({
    account,
    defaultPkg,
    className = '',
    condenced = false,
    priceContracts = {},
    products = [],
    isCart = false,
    showAllocations = false,
    showAudience = false,
    ilsEnabled = false,
    isReadOnly = false,
    cartId = null,
    canDelete = true,
    showImages = true,
    showAllocHeader = true,
    showAllocTotal = true,
    showListPrice = true,
    showTotal = true,
    emptyRowCount = 0,
    meta = ['authors', 'narrators', 'isbn', 'subtitle', 'studio', 'brand', 'sku'],
    currency = 'USD',
    territory = 'us',
    selectAll = () => {},
    onAllocChange = () => {},
    onQtyChange = () => {},
    onItemRemove = () => {},
    onItemSelect = () => {},
    onWarrantySelect = () => {},
    onWarrantyRemove = () => {},
    onAddItem = () => {},
    onPkgSelect = () => {}
}) => {
    let emptyRows = [];

    let prodColSpan = 1;
    if (showImages) {
        prodColSpan++;
    }

    return (
        <table
            className={classnames(className, {
                'cart-table': isCart,
                'product-table': !isCart,
                condenced: condenced
            })}
        >
            <thead>
                <tr>
                    <th className="checkbox" colSpan={prodColSpan}>
                        Product
                    </th>
                    {showAudience && <th className="l-text-center">Audience</th>}
                    {showListPrice && <th className="l-text-center">List Price</th>}
                    <th className="l-text-center">Your Price</th>
                    <th className="l-text-center">Qty</th>
                    <th className="l-text-center">Package Type</th>
                    {showTotal && <th className="l-text-center">Total</th>}
                    {!isReadOnly && <th className="l-text-center">{isCart ? canDelete && 'Remove' : 'Add to'}</th>}
                </tr>
            </thead>

            {(!products.length || !emptyRowCount) && (
                <tbody>
                    <tr>
                        <td colSpan={8}>No Products Found</td>
                    </tr>
                </tbody>
            )}

            {products.map((product, index) => {
                let pcDiscount = productUtils.getContractDiscount(product, priceContracts);
                let discount = product.discount ? product.discount : pcDiscount;
                let _meta = [...meta];
                let readOnly = isReadOnly || product.format.includes('warranty');

                if (isCart && product.format === 'launchpad') {
                    _meta.push('warranty');
                }

                return (
                    <tbody key={`${product.sku}_row_${index}`}>
                        <TableRow
                            product={product}
                            canDelete={canDelete}
                            isReadOnly={readOnly}
                            discount={discount}
                            isCart={isCart}
                            cartId={cartId}
                            territory={territory}
                            currency={currency}
                            onQtyChange={onQtyChange}
                            onItemRemove={onItemRemove}
                            onItemSelect={onItemSelect}
                            onItemAdd={onAddItem}
                            defaultPkg={defaultPkg}
                            hasAllocations={showAllocations}
                            showImage={showImages}
                            showListPrice={showListPrice}
                            showAudience={showAudience}
                            showTotal={showTotal}
                            meta={_meta}
                            onWarrantySelect={onWarrantySelect}
                            onWarrantyRemove={onWarrantyRemove}
                            onPkgSelect={onPkgSelect}
                        />
                        {showAllocations && (
                            <tr key={`${product.sku}_allocations`} className="ninexx_row">
                                <td colSpan="8">
                                    <AllocationsTable
                                        account={account}
                                        isReadOnly={isReadOnly}
                                        product={product}
                                        cartId={cartId}
                                        allocations={product.allocations}
                                        onAllocChange={onAllocChange}
                                        showHeader={showAllocHeader}
                                        showTotal={showAllocTotal}
                                    />
                                </td>
                            </tr>
                        )}
                    </tbody>
                );
            })}
            {!!emptyRows.length && <tbody>{emptyRows}</tbody>}
        </table>
    );
};

export default ProductTable;
